import { createSlice } from "@reduxjs/toolkit";

const storedAuth = sessionStorage.getItem("user")
  ? JSON.parse(sessionStorage.getItem("user") || "{}")
  : null;

const initialState = {
  isAuthenticated: storedAuth ? true : false,
  user: storedAuth,
  token: sessionStorage.getItem("token") || null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.token = null;
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
